import type { Scalars } from 'api-graphql-types/server'
function formatMatchingEventDate(
  dateString: Scalars['ISO8601DateTime']['output'] | null | undefined,
  locale: string
): string {
  if (!dateString) return ''
  const date = new Date(dateString)
  if (Number.isNaN(date.getTime())) return ''

  const formatter = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: locale.startsWith('de') ? '2-digit' : 'short',
    day: '2-digit',
    weekday: 'short',
  })

  return formatter.format(date)
}

function toISO8601DateTime(date: Date): Scalars['ISO8601DateTime']['output'] {
  return date.toISOString() as Scalars['ISO8601DateTime']['output']
}

export { formatMatchingEventDate, toISO8601DateTime }
